import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { MatterUser } from '../../../models/matter-user';

import { AlertService } from '../../../services/common/alert.service';
import { MatterUserService } from '../../../services/matters/matter-user.service';

@Component({
  selector: 'app-matter-user-form',
  templateUrl: './matter-user-form.component.html',
  styleUrls: ['./matter-user-form.component.css'],
})
export class MatterUserFormComponent implements OnInit {
  @Input() matter_id: number;

  @Input() matter_user_id: number;

  @Output() formResult: EventEmitter<string> = new EventEmitter();

  form_options: any = {
    matter_user_types: [],
  };

  users_list: Array<any> = [];

  matter_user: MatterUser = new MatterUser();

  formSubmitting: boolean = false;
  formSubmitted: boolean = false;

  constructor(private alertService: AlertService, private matterUserService: MatterUserService) {
    this.matterUserService.getFormOptions().then((response_json) => {
      this.form_options = response_json;
      if (!this.matter_user_id) {
        this.matter_user.matter_user_type_id = this.form_options.matter_user_types[0].id;
        this.getUsers(true);
      }
    });
  }

  ngOnInit() {
    if (this.matter_user_id)
      this.matterUserService.getMatterUser(this.matter_user_id).then((response_json) => {
        this.matter_user = response_json;
        this.getUsers();
      });
    else if (this.matter_id) this.matter_user.matter_id = this.matter_id;
  }

  getUsers(assign_first_user: boolean = false) {
    this.matterUserService.getUsers(this.matter_user.matter_user_type_id).then((response_json) => {
      this.users_list = response_json;
      if (assign_first_user) {
        for (let user of this.users_list) {
          if (this.matter_user.user_id == user.user_id) return;
        }
        if (this.users_list[0]) this.matter_user.user_id = this.users_list[0].user_id;
        else this.matter_user.user_id = null;
      }
    });
  }

  fieldShowErrorMessage(field: any) {
    if (!field.valid && this.formSubmitted) return true;
    else return false;
  }

  saveMatterUser(formValid: boolean) {
    this.formSubmitted = true;
    if (formValid) {
      this.formSubmitting = true;
      let scope = this;
      this.matterUserService
        .saveMatterUser(this.matter_user)
        .then((response_json) => {
          this.formSubmitting = false;
          if (response_json.text == 'Matter user created' || response_json.text == 'Matter user updated') {
            this.alertService.alert_status_success(response_json.text);
            this.formResult.emit('Form Saved');
          } else this.alertService.alert_status_danger(response_json.text || 'Error saving matter user');
        })
        .catch(function () {
          scope.formSubmitting = false;
          scope.alertService.alert_status_danger('Error saving matter user');
        });
    }
  }

  cancelForm() {
    this.formResult.emit('Form Cancelled');
  }
}
